import { Chip, ChipProps } from '@nexelem/components';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

type FormFilterChipProps<Value extends FieldValues> = ChipProps & Omit<UseControllerProps<Value>, 'disabled'>;

export const FormFilterChip = ({ disabled, ...props }: FormFilterChipProps<FieldValues>) => {
  const { field } = useController(props);

  return <Chip {...props} {...field} disabled={disabled} />;
};
